import { translate } from "../i18n";
// Editorial selection: update the issue and recommendations together each month.
// Rankings express planning priority, not sales performance or stock availability.
export const seasonalIssue = {
  edition: translate("Settembre 2026"),
  theme: translate("Il Natale si prepara adesso."),
  intro: translate("Le idee migliori meritano tempo. Questo mese scegli a chi vuoi fare un regalo, cosa vuoi comunicare e quando vuoi essere pronto. Al resto diamo forma insieme."),
  items: [{
    title: translate("Regali aziendali personalizzati"),
    audience: translate("Per clienti e collaboratori"),
    why: translate("Un oggetto utile, una confezione curata, un messaggio personale. Parti dalle persone che vuoi ringraziare."),
    action: translate("Definisci destinatari, quantit\xE0 e budget per regalo."),
    service: translate("Soluzioni per aziende"),
    icon: "gift"
  }, {
    title: translate("Calendari 2027"),
    audience: translate("Per restare presenti tutto l\u2019anno"),
    why: translate("Da tavolo o da parete, con immagini e contenuti che raccontano la tua attivit\xE0. Un progetto da costruire prima di dicembre."),
    action: translate("Scegli il formato e raccogli fotografie, logo e ricorrenze."),
    service: translate("Stampati aziendali"),
    icon: "calendar"
  }, {
    title: translate("Confezioni ed etichette regalo"),
    audience: translate("Per negozi, produttori e aziende"),
    why: translate("Scatole, fascette ed etichette possono trasformare un prodotto in un regalo riconoscibile, coordinato con il tuo marchio."),
    action: translate("Parti dalle misure del prodotto e dall\u2019effetto che vuoi ottenere."),
    service: translate("Adesivi & etichette"),
    icon: "package"
  }, {
    title: translate("Biglietti d\u2019auguri"),
    audience: translate("Per un grazie che si tocca"),
    why: translate("Carta, finiture e parole scelte bene. Un biglietto pu\xF2 accompagnare un dono o arrivare da solo, con un messaggio dedicato."),
    action: translate("Prepara il messaggio e la lista dei destinatari."),
    service: translate("Stampati aziendali"),
    icon: "card"
  }, {
    title: translate("Vetrine e materiali per le feste"),
    audience: translate("Per negozi, locali ed eventi"),
    why: translate("Vetrofanie, locandine e materiali promozionali con la stessa identit\xE0. Il Natale pu\xF2 iniziare gi\xE0 dalla tua vetrina."),
    action: translate("Indica spazi, misure e data di allestimento desiderata."),
    service: translate("Grande formato"),
    icon: "window"
  }],
  privateItems: [{
    title: translate("Fotolibri dei tuoi ricordi"),
    audience: translate("Per la famiglia e le persone care"),
    why: translate("Un viaggio, un anno insieme, i primi momenti di una nuova famiglia. Raccogli le foto che contano e trasformale in un regalo da sfogliare."),
    action: translate("Seleziona le fotografie originali e immagina un ordine o un piccolo racconto."),
    service: translate("Stampe per privati"),
    icon: "book"
  }, {
    title: translate("Calendari con le tue foto"),
    audience: translate("Per regalare un anno di ricordi"),
    why: translate("Dodici mesi di fotografie, persone e luoghi speciali. Un\u2019idea per nonni, amici e famiglia, con ricorrenze da ricordare."),
    action: translate("Scegli le foto per i mesi e annota compleanni o date importanti."),
    service: translate("Stampe per privati"),
    icon: "calendar"
  }, {
    title: translate("Biglietti d\u2019auguri con foto"),
    audience: translate("Per auguri davvero personali"),
    why: translate("Una fotografia e poche parole tue. Per accompagnare un regalo o mandare un pensiero a chi \xE8 lontano."),
    action: translate("Prepara una foto, un messaggio e il numero di biglietti desiderato."),
    service: translate("Stampe per privati"),
    icon: "card"
  }, {
    title: translate("Stampe fotografiche da regalare"),
    audience: translate("Per dare spazio a un ricordo"),
    why: translate("Una foto speciale pu\xF2 diventare una stampa da esporre. Valutiamo insieme dimensioni e supporto in base all\u2019immagine."),
    action: translate("Porta il file originale e indica dove vorresti esporre la stampa."),
    service: translate("Grande formato"),
    icon: "photo"
  }, {
    title: translate("Etichette e cartoncini regalo"),
    audience: translate("Per pacchetti fatti con cura"),
    why: translate("Nomi, piccoli messaggi e disegni per personalizzare i tuoi regali, le conserve fatte in casa o la tavola delle feste."),
    action: translate("Prepara nomi e testi; indica su cosa applicherai etichette o cartoncini."),
    service: translate("Adesivi & etichette"),
    icon: "package"
  }]
};
